import { render, staticRenderFns } from "./ReservierungBestellungArtikel.vue?vue&type=template&id=2f01b6aa"
import script from "./ReservierungBestellungArtikel.vue?vue&type=script&lang=ts"
export * from "./ReservierungBestellungArtikel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports